import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from '../common/BrandLogo';
import { useTheme } from '../../context/ThemeContext';

export default function PublicLayout() {
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-base)] text-[var(--text-main)] font-sans transition-colors duration-300 flex flex-col">
      <header className="sticky top-0 z-50 bg-[var(--bg-base)]/80 backdrop-blur-md border-b border-[var(--border-subtle)]">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/">
            <BrandLogo />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-bold uppercase tracking-widest text-[var(--text-secondary)] hover:text-[var(--text-main)] transition-colors">
              Inicio
            </Link>
            <Link to="/blog" className="text-sm font-bold uppercase tracking-widest text-[var(--text-secondary)] hover:text-[var(--text-main)] transition-colors">
              Blog
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <button 
              onClick={toggleTheme}
              className="w-10 h-10 rounded-full flex items-center justify-center text-[var(--text-secondary)] hover:bg-[var(--bg-surface)] hover:text-[var(--text-main)] transition-all border border-transparent hover:border-[var(--border-subtle)]"
            >
              <SafeIcon name={isDark ? 'Sun' : 'Moon'} className="w-5 h-5" />
            </button>
            <button 
              onClick={() => navigate('/login')}
              className="hidden md:flex gfi-gradient-bg text-brand-navy px-6 py-2.5 rounded-full font-black text-xs uppercase tracking-widest transition-all transform hover:scale-105 shadow-lg"
            >
              Entrar
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-[var(--bg-surface)] border-t border-[var(--border-subtle)] py-12 text-center">
        <div className="flex items-center justify-center mb-4 opacity-50">
          <BrandLogo size="md" />
        </div>
        <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)]">
          © {new Date().getFullYear()} GFI Latino. Todos los derechos reservados.
        </p>
      </footer>
    </div>
  );
}
